import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PartnerFirm } from '@app/core/state/types/partner.types';
import { BlFrontendHeaderComponent } from 'src/app/core/wrappers/bl-frontend-header.component';

@Component({
  selector: 'app-partnerprogram-profile-card',
  template: `
    <div
      class="flex bg-white p-8 pb-10 shadow rounded-xl relative"
      [ngClass]="{ 'flex-row': !column, 'flex-col': column, 'h-full': fullHeight }">
      <div *ngIf="header">
        <bl-frontend-header size="h4" [text]="header"></bl-frontend-header>
      </div>
      <div
        class="flex"
        [ngClass]="{
          'flex-row': !column,
          'items-center': !column,
          'flex-col': column,
        }">
        <ng-content></ng-content>
      </div>
      <div class="absolute bottom-0 left-0 mb-6 ml-6">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, BlFrontendHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerProgramProfileCardComponent {
  @Input() level: number;
  @Input() data: PartnerFirm[];
  @Input() header: string;
  @Input() column = true;
  @Input() fullHeight = true;
}
